import React, { useEffect, useState } from "react";

import { tokenCreate_tokenCreate } from "@src/providers/CredentialProvider/__generated__/tokenCreate"
import { cartCreate_cartCreate_cart } from "@components/ProductPage/ProductDetailSummary/__generated__/cartCreate";
import { cartLinesAdd_cartLineAdd_cart } from "@components/ProductPage/ProductDetailSummary/__generated__/cartLinesAdd";
import { gaV4SetUserId } from "@utils";

export const useCurrentUser = () => {
  const userKey = 'currentUser';
  const item = localStorage.getItem(userKey);
  const localCurrentUser = JSON.parse(item);
  const [currentUser, setCurrentUserState] = React.useState<tokenCreate_tokenCreate>(localCurrentUser);

  const setCurrentUser = (user: tokenCreate_tokenCreate) => {
    setCurrentUserState(user);
    localStorage.setItem(userKey, JSON.stringify(user));
  };

  const logOut = async () => {
    localStorage.removeItem(userKey);
    setCurrentUserState(null);
    await gaV4SetUserId();
    return {}
  };

  return { currentUser, setCurrentUser, logOut };
}

export const useAnonymousCart = () => {
  const maccaronAnonymousCartKey = 'maccaronAnonymousCart';
  const mgsAnonymousCartKey = 'mgsAnonymousCart';

  const localMaccaronAnonymousCart = JSON.parse(localStorage.getItem(maccaronAnonymousCartKey));
  const localMgsAnonymousCart = JSON.parse(localStorage.getItem(mgsAnonymousCartKey));

  const [anonymousCart, setAnonymousCartState] = useState<cartCreate_cartCreate_cart>(localMaccaronAnonymousCart);
  const [mgsAnonymousCart, setMgsAnonymousCartState] = useState<cartCreate_cartCreate_cart>(localMgsAnonymousCart);

  const setAnonymousCart = (cart: cartCreate_cartCreate_cart | cartLinesAdd_cartLineAdd_cart) => {
    setAnonymousCartState(cart);
    localStorage.setItem(maccaronAnonymousCartKey, JSON.stringify(cart));
  };

  const setMgsAnonymousCart = (cart: cartCreate_cartCreate_cart | cartLinesAdd_cartLineAdd_cart) => {
    setMgsAnonymousCartState(cart);
    localStorage.setItem(mgsAnonymousCartKey, JSON.stringify(cart));
  };

  const removeAnonymousCart = () => {
    localStorage.removeItem(maccaronAnonymousCartKey);
    setAnonymousCartState(null);
  };

  const removeMgsAnonymousCart = () => {
    localStorage.removeItem(mgsAnonymousCartKey);
    setMgsAnonymousCartState(null);
  };

  return {
    anonymousCart,
    setAnonymousCart,
    removeAnonymousCart,
    mgsAnonymousCart,
    setMgsAnonymousCart,
    removeMgsAnonymousCart
  };
};

export const useLogOut = () => {

}

export * from './useServiceWorker';

export default function useOnScreen(ref) {

  const [isIntersecting, setIntersecting] = useState(false)

  const observer = new IntersectionObserver(
    ([entry]) => setIntersecting(entry.isIntersecting)
  )

  useEffect(() => {
    observer.observe(ref.current)
    // Remove the observer as soon as the component is unmounted
    return () => { observer.disconnect() }
  }, [])

  return isIntersecting
}
